import { http } from '@/libs/util.js'
import util from '@/libs/util.js'

export const { 
    opening_shop_order_save,
    opening_shop_order_query_mine,
    opening_shop_order_detail,
    opening_shop_order_query,
    third_party_shop_query,
    third_party_shop_save,
    third_party_shop_modify_status,
    closing_shop_order_save,
    third_party_shop_transfer_records,
    third_party_shop_export
 } = util.api || {}


 // 新增预算申请
export function applyOpoenShopApi(params) {
    return http.post(opening_shop_order_save, params)
}

// 开店申请列表

export function getApplyOpoenShopListApi(params) {
    return http.get(opening_shop_order_query_mine, params)
}

// 端获取列表
export function getApplyOpenShopDetailApi(params) {
    return http.get(opening_shop_order_detail, params)
}

// 审批端
export function getApplyOpenShopDetailSpApi(params) {
    return http.get(opening_shop_order_query, params)
}

// 第三方店铺 列表

export function getThirdPartyShopQueryListApi(params) {
    return http.get(third_party_shop_query, params)
}

// third_party_shop_save
export function saveThirdPartyShopApi(params) {
    return http.post(third_party_shop_save, params)
}

export function changeStatusShopApi(params) {
    return http.post(third_party_shop_modify_status, params)
}

export function closeShopApi(params) {
    return http.post(closing_shop_order_save, params)
}

export function getThirdPartyShopTransferRecordsApi(params) {
    return http.get(third_party_shop_transfer_records, params)
}